import { useAnimations } from "../../hooks/useAnimations";

export const useHomeAnimations = useAnimations;
